//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The application responsible for printing a label */
export const PrintFrom = {
    /** The label will be printed by the kiosk */
    Client: 0,

    /** The label will be printed by the server. */
    Server: 1
} as const;

/** The application responsible for printing a label */
export const PrintFromDescription: Record<number, string> = {
    0: "Client",

    1: "Server"
};

/** The application responsible for printing a label */
export type PrintFrom = typeof PrintFrom[keyof typeof PrintFrom];
